<template>
  <div class="landing-page-root" :class="{'light-mode': !darkMode}">

    <!-- Theme Toggle -->
    <button class="lp-theme-toggle" @click="toggleTheme" :title="darkMode?'Switch to Light':'Switch to Dark'">
      <i :class="darkMode?'mdi mdi-white-balance-sunny':'mdi mdi-moon-waning-crescent'" style="font-size:18px;"></i>
    </button>
    <div id="layout-wrapper">

      <!-- NAVBAR -->
      <nav class="landing-nav" :class="{ 'nav-scrolled': isScrolled }">
        <div class="container d-flex align-items-center justify-content-between py-2">
          <a href="javascript:void(0)" @click="$router.push('/')" class="nav-brand">
            <img src="assets/images/flockr_logo.png" alt="Flockr" style="height:38px;" />
          </a>
          <div class="d-none d-lg-flex align-items-center">
            <a href="#features" class="landing-nav-link" @click.prevent="scrollTo('features')">Features</a>
            <a href="#how-it-works" class="landing-nav-link" @click.prevent="scrollTo('how-it-works')">How It Works</a>
            <a href="#marketplace" class="landing-nav-link" @click.prevent="scrollTo('marketplace')">Marketplace</a>
            <a href="#ecosystem" class="landing-nav-link" @click.prevent="scrollTo('ecosystem')">Ecosystem</a>
            <a href="#pricing" class="landing-nav-link" @click.prevent="scrollTo('pricing')">Pricing</a>
            <span class="landing-nav-divider"></span>
            <template v-if="isLoggedIn">
              <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="btn btn-sm btn-outline-warning me-2"><i class="mdi mdi-view-dashboard me-1"></i>Dashboard</a>
              <a href="javascript:void(0)" @click="$router.push('/marketplace')" class="btn btn-sm btn-outline-warning me-2"><i class="mdi mdi-storefront me-1"></i>Marketplace</a>
              <a v-if="isAdmin" href="javascript:void(0)" @click="$router.push('/admin')" class="btn btn-sm btn-outline-danger me-2"><i class="mdi mdi-shield-crown me-1"></i>Admin</a>
              <div class="landing-user-pill" @click="showUserDrop=!showUserDrop">
                <user-avatar :src="userAvatar" :name="userName" size="sm" />
                <span style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ userName }}</span>
                <i class="mdi mdi-chevron-down" style="color:var(--fm-s,#6B6356);font-size:14px;"></i>
              </div>
              <div v-if="showUserDrop" class="landing-user-drop">
                <a href="javascript:void(0)" @click="$router.push('/my-listings');showUserDrop=false" class="landing-drop-item"><i class="mdi mdi-tag-multiple me-2"></i>My Listings</a>
                <a href="javascript:void(0)" @click="$router.push('/my-offers');showUserDrop=false" class="landing-drop-item"><i class="mdi mdi-handshake me-2"></i>My Offers</a>
                <a href="javascript:void(0)" @click="$router.push('/sell/create');showUserDrop=false" class="landing-drop-item"><i class="mdi mdi-plus-circle me-2"></i>New Listing</a>
                <div style="border-top:1px solid var(--fm-br,#2A2520);margin:6px 0;"></div>
                <a href="javascript:void(0)" @click="logout" class="landing-drop-item" style="color:#FF6B6B;"><i class="mdi mdi-logout me-2"></i>Sign Out</a>
              </div>
            </template>
            <template v-else>
              <a href="javascript:void(0)" @click="$router.push('/login')" class="btn btn-sm btn-outline-warning me-2">Sign In</a>
              <a href="javascript:void(0)" @click="$router.push('/register')" class="btn btn-sm btn-warning text-dark fw-bold">Get Started Free</a>
            </template>
          </div>
          <div class="d-flex align-items-center d-lg-none" style="gap:8px;">
            <button class="lp-theme-toggle-mobile" @click="toggleTheme" :title="darkMode?'Switch to Light':'Switch to Dark'">
              <i :class="darkMode?'mdi mdi-white-balance-sunny':'mdi mdi-moon-waning-crescent'" style="font-size:18px;"></i>
            </button>
            <button class="btn btn-link p-0" style="color:var(--fm-h,#F5F0E8);" @click="mobileMenuOpen = !mobileMenuOpen">
              <i class="mdi mdi-menu" style="font-size:28px;" v-if="!mobileMenuOpen"></i>
              <i class="mdi mdi-close" style="font-size:28px;" v-else></i>
            </button>
          </div>
        </div>
        <div v-if="mobileMenuOpen" class="landing-mobile-menu d-lg-none">
          <a href="#features" class="landing-mobile-link" @click.prevent="scrollTo('features'); mobileMenuOpen=false">Features</a>
          <a href="#how-it-works" class="landing-mobile-link" @click.prevent="scrollTo('how-it-works'); mobileMenuOpen=false">How It Works</a>
          <a href="#marketplace" class="landing-mobile-link" @click.prevent="scrollTo('marketplace'); mobileMenuOpen=false">Marketplace</a>
          <a href="#ecosystem" class="landing-mobile-link" @click.prevent="scrollTo('ecosystem'); mobileMenuOpen=false">Ecosystem</a>
          <a href="#pricing" class="landing-mobile-link" @click.prevent="scrollTo('pricing'); mobileMenuOpen=false">Pricing</a>
          <div class="pt-3">
            <template v-if="isLoggedIn">
              <a href="javascript:void(0)" @click="$router.push('/dashboard');mobileMenuOpen=false" class="btn btn-outline-warning w-100 mb-2"><i class="mdi mdi-view-dashboard me-1"></i>Dashboard</a>
              <a href="javascript:void(0)" @click="$router.push('/marketplace');mobileMenuOpen=false" class="btn btn-outline-warning w-100 mb-2"><i class="mdi mdi-storefront me-1"></i>Marketplace</a>
              <a v-if="isAdmin" href="javascript:void(0)" @click="$router.push('/admin');mobileMenuOpen=false" class="btn btn-outline-danger w-100 mb-2"><i class="mdi mdi-shield-crown me-1"></i>Admin</a>
              <a href="javascript:void(0)" @click="logout" class="btn btn-outline-danger w-100"><i class="mdi mdi-logout me-1"></i>Sign Out</a>
            </template>
            <template v-else>
              <a href="javascript:void(0)" @click="$router.push('/login')" class="btn btn-outline-warning w-100 mb-2">Sign In</a>
              <a href="javascript:void(0)" @click="$router.push('/register')" class="btn btn-warning text-dark fw-bold w-100">Get Started Free</a>
            </template>
          </div>
        </div>
      </nav>

      <!-- HERO -->
      <section class="landing-hero">
        <div class="container">
          <div class="row align-items-center" style="min-height:calc(100vh - 80px); padding-top:80px;">
            <div class="col-lg-7">
              <div class="mb-3">
                <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2"><i class="mdi mdi-shield-check me-1"></i> Trusted by 5,000+ Farmers Across East Africa</span>
              </div>
              <h1 class="landing-hero-title">Buy, Sell &amp; Manage<br/><span style="color:#BFA164;">Livestock Smarter</span></h1>
              <p class="landing-hero-subtitle mt-3">Flockr is Africa's all-in-one livestock ecosystem — a trusted marketplace, farm management tool, vet telemedicine platform, transport network, and insurance gateway. Everything a farmer, trader, or agribusiness needs in one place.</p>
              <div class="mt-4">
                <a href="javascript:void(0)" @click="$router.push('/register')" class="btn btn-warning text-dark fw-bold btn-lg me-2 mb-2"><i class="mdi mdi-rocket-launch me-1"></i> Start For Free</a>
                <a href="#how-it-works" class="btn btn-outline-light btn-lg mb-2" @click.prevent="scrollTo('how-it-works')"><i class="mdi mdi-play-circle me-1"></i> See How It Works</a>
              </div>
              <div class="d-flex align-items-center mt-5 flex-wrap">
                <div class="text-center px-3"><div class="fw-bold fs-4" style="color:#BFA164;">47</div><small class="text-muted">Counties</small></div>
                <div class="landing-stat-divider"></div>
                <div class="text-center px-3"><div class="fw-bold fs-4" style="color:#BFA164;">15K+</div><small class="text-muted">Listings</small></div>
                <div class="landing-stat-divider"></div>
                <div class="text-center px-3"><div class="fw-bold fs-4" style="color:#BFA164;">98%</div><small class="text-muted">Escrow Success</small></div>
                <div class="landing-stat-divider"></div>
                <div class="text-center px-3"><div class="fw-bold fs-4" style="color:#BFA164;">24/7</div><small class="text-muted">Vet Access</small></div>
              </div>
            </div>
            <div class="col-lg-5 d-none d-lg-block">
              <div class="text-center">
                <div class="landing-phone-mockup">
                  <div class="landing-phone-screen">
                    <div class="text-center pb-2 mb-2 landing-phone-header">
                      <img src="assets/images/flockr_logo.png" alt="Flockr" style="height:28px;opacity:0.9;" />
                    </div>
                    <div v-if="phoneListings.length === 0" class="text-center py-3">
                      <div class="spinner-border spinner-border-sm text-warning" role="status"></div>
                    </div>
                    <div v-for="(pl, pli) in phoneListings" :key="'ph-'+pli" class="d-flex align-items-center py-2 landing-phone-row">
                      <div class="landing-phone-icon"><i :class="getSpeciesIcon(pl.species_name)" style="font-size:32px;color:#BFA164;"></i></div>
                      <div class="ms-2">
                        <div class="fw-semibold landing-phone-title">{{ pl.title }}</div>
                        <div class="fw-bold" style="font-size:14px;color:#BFA164;">KES {{ formatPrice(pl.price) }}</div>
                        <div class="landing-phone-meta"><i class="mdi mdi-map-marker"></i> {{ pl.county_name || pl.location }}</div>
                      </div>
                    </div>
                    <div class="text-center mt-3">
                      <span class="btn btn-sm btn-warning text-dark fw-bold px-4" @click="$router.push('/marketplace')">Browse Marketplace</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- TRUSTED BY -->
      <section class="py-4" style="background:var(--fm-bg2);border-bottom:1px solid var(--fm-br);">
        <div class="container">
          <p class="text-center text-muted mb-3" style="font-size:12px;letter-spacing:2px;font-weight:600;">INTEGRATED WITH PLATFORMS YOU ALREADY USE</p>
          <div class="d-flex justify-content-center align-items-center flex-wrap" style="gap:48px;">
            <div class="text-center text-muted"><i class="mdi mdi-cellphone-wireless d-block" style="font-size:32px;"></i><small class="fw-semibold">M-Pesa</small></div>
            <div class="text-center text-muted"><i class="mdi mdi-shield-check d-block" style="font-size:32px;"></i><small class="fw-semibold">KVB Verified</small></div>
            <div class="text-center text-muted"><i class="mdi mdi-truck-check d-block" style="font-size:32px;"></i><small class="fw-semibold">NTSA Compliant</small></div>
            <div class="text-center text-muted"><i class="mdi mdi-certificate d-block" style="font-size:32px;"></i><small class="fw-semibold">Insurance Partners</small></div>
            <div class="text-center text-muted"><i class="mdi mdi-chart-line d-block" style="font-size:32px;"></i><small class="fw-semibold">Market Data</small></div>
          </div>
        </div>
      </section>

      <!-- FEATURES -->
      <section id="features" class="py-5" style="background:var(--fm-bg2);">
        <div class="container">
          <div class="text-center mb-5">
            <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">THE PLATFORM</span>
            <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">One Ecosystem. Everything Livestock.</h2>
            <p class="text-muted mx-auto" style="max-width:600px;">From the farm gate to the buyer's hand — Flockr covers every step of the livestock value chain</p>
          </div>
          <div class="row g-4">
            <div class="col-lg-4 col-md-6" v-for="(f, fi) in features" :key="fi">
              <div class="card h-100 landing-feature-card" :style="themeCardStyle">
                <div class="card-body p-4" :style="themeCardBodyStyle">
                  <div class="landing-feature-icon mb-3" :style="'background:' + f.bgColor"><i :class="f.icon + ' font-size-24'" :style="'color:' + f.iconColor"></i></div>
                  <h5 class="fw-bold mb-2 landing-theme-heading landing-text-17" :style="themeHeadingStyle">{{ f.title }}</h5>
                  <p class="mb-3 landing-theme-text landing-copy-14" :style="themeMutedStyle">{{ f.desc }}</p>
                  <div class="mb-3"><span class="landing-feature-tag" v-for="(tag, ti) in f.tags" :key="ti">{{ tag }}</span></div>
                  <a href="javascript:void(0)" @click="$router.push(f.link)" style="color:#BFA164;font-size:13px;font-weight:600;text-decoration:none;">{{ f.linkText }} <i class="mdi mdi-arrow-right"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- HOW IT WORKS -->
      <section id="how-it-works" class="py-5" style="background:var(--fm-bg1);">
        <div class="container">
          <div class="text-center mb-5">
            <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">SIMPLE PROCESS</span>
            <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">How Flockr Works</h2>
            <p class="text-muted">Whether you're buying, selling, or managing — we've made it simple</p>
          </div>
          <div class="mb-5" v-for="(flow, fi) in flows" :key="fi">
            <h4 class="mb-4" style="color:#BFA164;font-weight:700;"><i :class="flow.icon" class="me-2"></i> {{ flow.title }}</h4>
            <div class="row g-4">
              <div class="col-lg-3 col-md-6" v-for="(step, si) in flow.steps" :key="si">
                <div class="card h-100 landing-step-card" :style="themeCardStyle">
                  <div class="card-body p-4 text-center" :style="themeCardBodyStyle">
                    <div class="landing-step-number">{{ si + 1 }}</div>
                    <div class="my-3" style="font-size:36px;color:#BFA164;"><i :class="step.icon"></i></div>
                    <h6 class="fw-bold mb-2 landing-theme-heading" :style="themeHeadingStyle">{{ step.title }}</h6>
                    <p class="mb-0 landing-theme-text landing-copy-13" :style="themeMutedStyle">{{ step.desc }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- MARKETPLACE PREVIEW -->
      <section id="marketplace" class="py-5" style="background:var(--fm-bg2);">
        <div class="container">
          <div class="text-center mb-5">
            <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">LIVE MARKETPLACE</span>
            <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">What's Trading Right Now</h2>
            <p class="text-muted">Browse thousands of verified livestock listings across Kenya</p>
          </div>
          <div class="d-flex justify-content-center flex-wrap mb-4" style="gap:8px;">
            <button v-for="species in speciesList" :key="species.key" class="btn btn-sm landing-species-tab" :class="activeSpecies === species.key ? 'active' : ''" @click="filterBySpecies(species.key)">
              <i :class="species.icon" class="me-1"></i> {{ species.name }}
            </button>
          </div>

          <div v-if="loadingListings" class="text-center py-5">
            <div class="spinner-border text-warning" role="status"><span class="sr-only">Loading...</span></div>
            <p class="mt-2 text-muted">Loading listings...</p>
          </div>

          <div v-else-if="sampleListings.length === 0" class="text-center py-5">
            <i class="mdi mdi-store-off" style="font-size:48px;color:var(--fm-s);"></i>
            <p class="text-muted mt-2">No listings available yet. Be the first to sell!</p>
            <a href="javascript:void(0)" @click="$router.push('/sell/create')" class="btn btn-warning text-dark fw-bold"><i class="mdi mdi-plus me-1"></i> Create Listing</a>
          </div>

          <div v-else class="row g-4">
            <div class="col-lg-3 col-md-6" v-for="(item, index) in sampleListings" :key="index">
              <div class="card landing-listing-card" :style="themeCardStyle" @click="$router.push('/marketplace/listing/' + item.id)">
                <div class="landing-listing-img">
                  <img v-if="item.primary_photo" :src="photoUrl(item.primary_photo)" :alt="item.title" style="width:100%;height:100%;object-fit:cover;" />
                  <i v-else :class="getSpeciesIcon(item.species_name)" style="font-size:64px;color:rgba(191,161,100,0.3);"></i>
                  <div style="position:absolute;top:10px;left:10px;display:flex;gap:6px;">
                    <span v-if="item.is_verified" class="badge bg-success bg-opacity-25 text-success" style="font-size:10px;"><i class="mdi mdi-check-decagram"></i> Verified</span>
                  </div>
                  <button class="landing-save-btn"><i class="mdi mdi-heart-outline"></i></button>
                </div>
                <div class="card-body p-3" :style="themeCardBodyStyle">
                  <h6 class="fw-bold mb-1 landing-theme-heading landing-title-15" :style="themeHeadingStyle">{{ item.title }}</h6>
                  <div class="d-flex mb-1" style="gap:12px;font-size:12px;color:var(--fm-s);">
                    <span v-if="item.weight"><i class="mdi mdi-weight-kilogram"></i> {{ item.weight }} kg</span>
                    <span v-if="item.sex"><i class="mdi mdi-gender-male-female"></i> {{ item.sex }}</span>
                    <span v-if="item.age_text"><i class="mdi mdi-clock-outline"></i> {{ item.age_text }}</span>
                  </div>
                  <div class="mb-2" style="font-size:12px;color:var(--fm-m);"><i class="mdi mdi-map-marker"></i> {{ item.county_name || item.location }}</div>
                  <div class="d-flex justify-content-between align-items-center pt-2" style="border-top:1px solid var(--fm-br);">
                    <div class="fw-bold" style="font-size:18px;color:#BFA164;">KES {{ formatPrice(item.price) }}</div>
                    <div class="d-flex align-items-center" style="gap:4px;font-size:12px;color:var(--fm-s);">
                      <div class="landing-seller-avatar">{{ getInitials(item.seller_name) }}</div>
                      <span>{{ item.seller_name }}</span>
                      <i class="mdi mdi-star text-warning" v-if="item.seller_rating"></i>
                      <span v-if="item.seller_rating">{{ item.seller_rating }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mt-5">
            <a href="javascript:void(0)" @click="$router.push('/marketplace')" class="btn btn-warning text-dark fw-bold btn-lg me-2"><i class="mdi mdi-store me-1"></i> Browse All Listings</a>
            <a href="javascript:void(0)" @click="$router.push('/sell/create')" class="btn btn-outline-warning btn-lg"><i class="mdi mdi-plus me-1"></i> Sell Your Livestock</a>
          </div>
        </div>
      </section>

      <!-- ECOSYSTEM -->
      <section id="ecosystem" class="py-5" style="background:var(--fm-bg1);">
        <div class="container">
          <div class="text-center mb-5">
            <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">COMPLETE PLATFORM</span>
            <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">The Flockr Ecosystem</h2>
            <p class="text-muted mx-auto" style="max-width:600px;">Every player in the livestock value chain, connected on one platform</p>
          </div>
          <div class="row g-4 justify-content-center">
            <div class="col-lg-4 col-md-6" v-for="(eco, ei) in ecoCards" :key="ei">
              <div class="card h-100 landing-eco-card" :style="themeCardStyle">
                <div class="card-body p-4" :style="themeCardBodyStyle">
                  <div style="font-size:40px;color:#BFA164;margin-bottom:12px;"><i :class="eco.icon"></i></div>
                  <h5 class="fw-bold mb-2 landing-theme-heading" :style="themeHeadingStyle">{{ eco.title }}</h5>
                  <p class="mb-3 landing-theme-text landing-copy-14" :style="themeMutedStyle">{{ eco.desc }}</p>
                  <ul class="list-unstyled mb-0">
                    <li v-for="(item, ii) in eco.items" :key="ii" class="d-flex align-items-center py-1 landing-theme-text" style="font-size:13px;gap:8px;">
                      <i class="mdi mdi-check" style="color:#BFA164;"></i> {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- M-PESA TRUST -->
      <section class="py-5" style="background:var(--fm-bg2);">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">SECURE PAYMENTS</span>
              <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">M-Pesa Escrow Protection</h2>
              <p class="mt-3 mb-4" style="font-size:16px;color:var(--fm-m);line-height:1.7;">Every transaction on Flockr is protected by our escrow system. When a buyer pays, the money is held securely until they confirm they've received the animal in the agreed condition. No more sending money and hoping for the best.</p>
              <div class="d-flex flex-column" style="gap:14px;">
                <div class="d-flex align-items-center" style="gap:12px;font-size:15px;color:var(--fm-h);" v-for="(tf, tfi) in trustFeatures" :key="tfi">
                  <i class="mdi mdi-check-circle font-size-20" style="color:#BFA164;"></i>
                  <span>{{ tf }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mt-4 mt-lg-0">
              <div class="card landing-escrow-card" :style="themeCardStyle">
                <div class="card-body p-4" :style="themeCardBodyStyle">
                  <div class="d-flex align-items-center justify-content-center mb-4">
                    <div class="landing-escrow-icon" style="background:rgba(80,165,241,.15);color:#50a5f1;"><i class="mdi mdi-account"></i></div>
                    <div style="width:60px;height:2px;background:var(--fm-br,#2A2520);"></div>
                    <div class="landing-escrow-icon landing-escrow-mid" style="background:rgba(191,161,100,.15);color:#BFA164;"><i class="mdi mdi-lock"></i></div>
                    <div style="width:60px;height:2px;background:var(--fm-br,#2A2520);"></div>
                    <div class="landing-escrow-icon" style="background:rgba(52,195,143,.15);color:#34c38f;"><i class="mdi mdi-account"></i></div>
                  </div>
                  <div class="d-flex justify-content-between mb-4 px-3" style="font-size:13px;font-weight:600;color:var(--fm-m);">
                    <span>Buyer Pays</span><span>Escrow Holds</span><span>Seller Receives</span>
                  </div>
                  <div class="d-flex flex-column px-3" style="gap:12px;">
                    <div class="d-flex align-items-center" style="gap:12px;font-size:14px;color:var(--fm-m);" v-for="(tl, tli) in escrowTimeline" :key="tli">
                      <div class="landing-tl-dot" :class="{ active: tl.active }"></div>
                      <span>{{ tl.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- PRICING -->
      <section id="pricing" class="py-5" style="background:var(--fm-bg1);">
        <div class="container">
          <div class="text-center mb-5">
            <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">PRICING</span>
            <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">Free Forever. We Only Earn When You Earn.</h2>
            <p class="text-muted">No subscriptions. No setup fees. No hidden charges. A small commission on real transactions — that's it.</p>
          </div>
          <div class="row g-4 justify-content-center">
            <div class="col-lg-8">
              <div class="card landing-pricing-card landing-pricing-popular" :style="themeCardStyle">
                <div class="landing-popular-badge">EVERYONE GETS THIS</div>
                <div class="card-body p-4 p-md-5" :style="themeCardBodyStyle">
                  <div class="text-center mb-4">
                    <div class="fw-bold mb-1 landing-theme-text" style="font-size:16px;">Flockr Free</div>
                    <div class="fw-bold landing-theme-heading" style="font-size:52px;line-height:1;">KES 0<span class="landing-theme-muted" style="font-size:18px;font-weight:400;">/month</span></div>
                    <p class="landing-theme-muted mt-2" style="font-size:14px;">Unlimited listings, unlimited animals, full farm management, AI Vet, market intel, community — all included.</p>
                  </div>

                  <div class="mb-4">
                    <div class="fw-bold landing-theme-heading mb-3" style="font-size:14px;letter-spacing:1px;text-transform:uppercase;">Commission rates</div>
                    <div v-for="(row, ci) in commissionRates" :key="ci" class="d-flex align-items-center justify-content-between py-2" style="border-bottom:1px solid var(--fm-br);">
                      <div class="d-flex align-items-center" style="gap:10px;">
                        <i :class="row.icon" style="color:#BFA164;font-size:20px;"></i>
                        <div>
                          <div class="landing-theme-heading fw-semibold" style="font-size:14px;">{{ row.label }}</div>
                          <div class="landing-theme-muted" style="font-size:11px;">Paid by the {{ row.payer }}, deducted at settlement</div>
                        </div>
                      </div>
                      <div class="fw-bold" style="color:#BFA164;font-size:18px;">{{ row.rate }}</div>
                    </div>
                  </div>

                  <div class="mb-4 p-3" style="background:rgba(191,161,100,0.06);border:1px solid rgba(191,161,100,0.2);border-radius:10px;">
                    <div class="d-flex" style="gap:10px;">
                      <i class="mdi mdi-shield-check" style="color:#BFA164;font-size:24px;flex-shrink:0;"></i>
                      <div>
                        <div class="landing-theme-heading fw-semibold" style="font-size:13px;">No transaction, no fee.</div>
                        <div class="landing-theme-muted" style="font-size:12px;line-height:1.6;">If you don't sell, you don't pay. Browsing, listing, AI Vet, market reports, forum, and farm management are completely free — and always will be.</div>
                      </div>
                    </div>
                  </div>

                  <a href="javascript:void(0)" @click="$router.push('/register')" class="btn btn-warning text-dark fw-bold w-100 btn-lg">
                    <i class="mdi mdi-rocket-launch me-1"></i> Create Free Account
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-5" style="background:var(--fm-bg2);border-top:1px solid var(--fm-br);">
        <div class="container text-center py-4">
          <h2 class="fw-bold" style="font-size:36px;color:var(--fm-h);">Ready to Transform Your Livestock Business?</h2>
          <p class="mt-2 mb-4" style="font-size:18px;color:var(--fm-m);">Join thousands of farmers, traders, and agribusinesses already using Flockr</p>
          <div>
            <a href="javascript:void(0)" @click="$router.push('/register')" class="btn btn-warning text-dark fw-bold btn-lg me-2 mb-2"><i class="mdi mdi-rocket-launch me-1"></i> Create Free Account</a>
            <a href="javascript:void(0)" @click="$router.push('/marketplace')" class="btn btn-outline-light btn-lg mb-2"><i class="mdi mdi-store me-1"></i> Browse Marketplace</a>
          </div>
          <p class="text-muted mt-3" style="font-size:13px;">No credit card required. Free forever plan available.</p>
        </div>
      </section>

      <!-- FOOTER -->
      <footer style="background:var(--fm-bg1);padding:60px 0 0;border-top:1px solid var(--fm-br);">
        <div class="container">
          <div class="row g-4">
            <div class="col-lg-4">
              <img src="assets/images/flockr_logo.png" alt="Flockr" style="height:45px;" class="mb-3" />
              <p style="font-size:14px;color:var(--fm-m);line-height:1.7;max-width:340px;">Africa's livestock ledger. Buy, sell, and manage livestock smarter with escrow-protected payments, vet telemedicine, GPS transport tracking, and insurance — all in one platform.</p>
              <div class="d-flex" style="gap:12px;margin-top:16px;">
                <a href="#" class="landing-social-icon"><i class="mdi mdi-facebook"></i></a>
                <a href="#" class="landing-social-icon"><i class="mdi mdi-twitter"></i></a>
                <a href="#" class="landing-social-icon"><i class="mdi mdi-instagram"></i></a>
                <a href="#" class="landing-social-icon"><i class="mdi mdi-youtube"></i></a>
                <a href="#" class="landing-social-icon"><i class="mdi mdi-whatsapp"></i></a>
              </div>
            </div>
            <div class="col-lg-2 col-6" v-for="(col, ci) in footerColumns" :key="ci">
              <h6 class="fw-bold mb-3 text-uppercase" style="font-size:14px;color:var(--fm-h);letter-spacing:.5px;">{{ col.heading }}</h6>
              <ul class="list-unstyled">
                <li v-for="(link, li) in col.links" :key="li" class="mb-2">
                  <a href="javascript:void(0)" @click="$router.push(link.url)" style="color:var(--fm-m);text-decoration:none;font-size:14px;">{{ link.text }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="text-center py-3 mt-4" style="border-top:1px solid var(--fm-br);">
            <p class="mb-0 text-muted" style="font-size:13px;">&copy; {{ currentYear }} Flockr. Africa's Livestock Ledger. All rights reserved.</p>
          </div>
        </div>
      </footer>

    </div>
    <div class="rightbar-overlay"></div>
  </div>
</template>

<script>
/* eslint-disable */
import { executeJson, flocker, uploads } from "@/api";
import UserAvatar from "@/components/flockr-users/UserAvatar.vue";

export default {
  name: "LandingPage",
  components: { UserAvatar },
  data() {
    return {
      darkMode: (document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || 'light') !== 'light',
      themeObserver: null,
      isScrolled: false,
      mobileMenuOpen: false,
      showUserDrop: false,
      isLoggedIn: false,
      userName: '',
      userInitials: '',
      userAvatar: '',
      activeSpecies: 'all',

      // API-driven data
      speciesList: [],
      sampleListings: [],
      phoneListings: [],
      loadingListings: false,
      loadingSpecies: false,

      // Static content (UI text, not database data)
      features: [
        { title: 'Livestock Marketplace', desc: 'Buy and sell cattle, goats, sheep, poultry, pigs, camels, and more. Individual animals or batches. Verified sellers with escrow-protected payments.', icon: 'mdi mdi-store', bgColor: 'rgba(191,161,100,.12)', iconColor: '#BFA164', tags: ['Individual & Batch', 'Escrow Payments', 'Price Negotiation'], link: '/marketplace', linkText: 'Explore Marketplace' },
        { title: 'Farm Management', desc: 'Track every animal — weight, health, vaccinations, deworming, breeding, milk yields, egg production. Your complete digital farm record.', icon: 'mdi mdi-barn', bgColor: 'rgba(52,195,143,.12)', iconColor: '#34c38f', tags: ['Animal Profiles', 'Health Tracking', 'Production Records'], link: '/farm', linkText: 'Manage My Farm' },
        { title: 'Vet Services & Telemedicine', desc: 'Connect with KVB-registered vets for farm visits, video consultations, and emergency care. Plus AI-powered symptom checker for quick guidance.', icon: 'mdi mdi-stethoscope', bgColor: 'rgba(80,165,241,.12)', iconColor: '#50a5f1', tags: ['Telemedicine', 'AI Symptom Check', 'Emergency 24/7'], link: '/vets', linkText: 'Find a Vet' },
        { title: 'Transport & Logistics', desc: 'Book NTSA-compliant livestock transporters with GPS tracking, animal welfare checklists, and transit insurance. Know where your animals are in real-time.', icon: 'mdi mdi-truck-fast', bgColor: 'rgba(241,180,76,.12)', iconColor: '#f1b44c', tags: ['GPS Tracking', 'NTSA Verified', 'Welfare Checklists'], link: '/transport', linkText: 'Book Transport' },
        { title: 'Livestock Insurance', desc: 'Protect your investment with livestock, transit, and theft insurance from leading Kenyan providers. Instant policy issuance and digital claims processing.', icon: 'mdi mdi-shield-half-full', bgColor: 'rgba(155,89,182,.12)', iconColor: '#9b59b6', tags: ['Livestock Cover', 'Transit Insurance', 'Digital Claims'], link: '/insurance', linkText: 'Get Covered' },
        { title: 'Market Intelligence', desc: 'Real-time market prices by county, breed, and species. AI-powered price recommendations, market reports, and trend analysis to sell at the right time.', icon: 'mdi mdi-chart-areaspline', bgColor: 'rgba(26,188,156,.12)', iconColor: '#1abc9c', tags: ['Live Prices', 'AI Pricing', 'County Reports'], link: '/market', linkText: 'View Market Data' },
        { title: 'Bulk Buying & Aggregation', desc: 'Post buy requests for bulk orders. Aggregators can build trusted supplier networks, compare offers, and coordinate large-scale procurement effortlessly.', icon: 'mdi mdi-account-group', bgColor: 'rgba(231,76,60,.12)', iconColor: '#e74c3c', tags: ['Buy Requests', 'Supplier Networks', 'Bulk Orders'], link: '/marketplace/buy-requests', linkText: 'Post Buy Request' },
        { title: 'Agro-Input Shop', desc: 'Shop for animal feeds, supplements, veterinary drugs, farming equipment, and supplies. Delivered to your farm or pick up from nearby stockists.', icon: 'mdi mdi-package-variant-closed', bgColor: 'rgba(241,196,15,.12)', iconColor: '#f1c40f', tags: ['Feeds & Supplements', 'Vet Drugs', 'Equipment'], link: '/shop', linkText: 'Shop Now' },
        { title: 'Community & Learning', desc: 'Join farmer forums, read expert articles in English and Swahili, ask vets questions, and learn best practices from thousands of farmers across Kenya.', icon: 'mdi mdi-forum', bgColor: 'rgba(232,67,147,.12)', iconColor: '#e84393', tags: ['Farmer Forums', 'Expert Articles', 'EN & SW'], link: '/forum', linkText: 'Join Community' }
      ],

      flows: [
        { title: 'Buying Livestock', icon: 'mdi mdi-cart', steps: [
            { icon: 'mdi mdi-magnify', title: 'Search & Filter', desc: 'Browse listings by species, breed, county, price range. View photos, health records, and seller ratings.' },
            { icon: 'mdi mdi-handshake', title: 'Negotiate & Order', desc: 'Make offers, negotiate price directly with sellers. Place order with quantity and delivery preference.' },
            { icon: 'mdi mdi-cellphone-wireless', title: 'Pay via M-Pesa', desc: 'Pay securely. Funds are held in escrow — the seller gets paid only after you confirm delivery and quality.' },
            { icon: 'mdi mdi-truck-delivery', title: 'Receive & Inspect', desc: 'Collect or get delivery via Flockr Transport. Inspect for 48 hours. Approve to release payment, or raise a dispute.' }
          ]},
        { title: 'Selling Livestock', icon: 'mdi mdi-tag-plus', steps: [
            { icon: 'mdi mdi-camera-plus', title: 'List Your Animal', desc: 'Upload photos, set your price, add health records. List individual animals or full batches.' },
            { icon: 'mdi mdi-bell-ring', title: 'Receive Offers', desc: 'Get notified when buyers make offers. Negotiate, counter-offer, or accept. All within the platform.' },
            { icon: 'mdi mdi-package-variant', title: 'Hand Over', desc: 'Arrange pickup or book a Flockr transporter. Upload handover photos. Movement permit handled digitally.' },
            { icon: 'mdi mdi-wallet-plus', title: 'Get Paid', desc: 'Escrow releases automatically after buyer confirms. Withdraw to M-Pesa or bank instantly. No more bounced cheques.' }
          ]}
      ],

      ecoCards: [
        { icon: 'mdi mdi-account-cowboy-hat', title: 'Farmers', desc: 'List animals, manage your farm digitally, track health records, vaccinations, breeding, production — and sell directly to verified buyers.', items: ['Farm dashboard & analytics', 'Animal profiles with QR codes', 'Vaccination & deworming alerts', 'Direct marketplace access'] },
        { icon: 'mdi mdi-cart', title: 'Buyers & Traders', desc: 'Search verified listings, negotiate prices, pay via M-Pesa with escrow protection, and arrange transport — all from your phone.', items: ['Advanced search & filters', 'Escrow-protected payments', '48-hour inspection window', 'Bulk buy requests'] },
        { icon: 'mdi mdi-stethoscope', title: 'Veterinarians', desc: 'Reach more farmers through telemedicine, manage appointments, build your practice, and offer wellness subscription plans.', items: ['Video consultations', 'Digital prescriptions', 'Appointment management', 'Wellness program subscriptions'] },
        { icon: 'mdi mdi-truck', title: 'Transporters', desc: 'Get booked by buyers and sellers, manage your fleet, track trips with GPS, and earn consistently through the platform.', items: ['Trip management dashboard', 'GPS live tracking', 'Welfare checklists', 'Fleet & vehicle management'] },
        { icon: 'mdi mdi-shield-check', title: 'Insurance Partners', desc: 'Offer livestock, transit, and index-based insurance products to thousands of farmers. Digital policy issuance and claims management.', items: ['Instant policy issuance', 'Digital claims with evidence', 'Multiple coverage types', 'Partner dashboard'] },
        { icon: 'mdi mdi-package-variant', title: 'Input Suppliers', desc: 'Sell feeds, drugs, equipment, and supplements directly to farmers. Manage inventory, orders, and delivery through the Flockr product marketplace.', items: ['Product catalogue', 'Order management', 'Inventory tracking', 'Seller analytics'] }
      ],

      trustFeatures: [
        'Pay via M-Pesa STK Push — simple and instant',
        'Funds held in escrow until buyer confirms delivery',
        '48-hour inspection window after delivery',
        'Dispute resolution with dedicated mediators',
        'Seller receives funds directly to M-Pesa or bank',
        'Complete transaction history and audit trail'
      ],

      escrowTimeline: [
        { label: 'Order Placed', active: true },
        { label: 'Payment Received', active: true },
        { label: 'Animal Dispatched', active: true },
        { label: 'Buyer Inspects', active: false },
        { label: 'Funds Released', active: false }
      ],

      commissionRates: [
        { icon: 'mdi mdi-cow', label: 'Animal sale', rate: '3%', payer: 'seller' },
        { icon: 'mdi mdi-shopping', label: 'Agro-input order', rate: '5%', payer: 'seller' },
        { icon: 'mdi mdi-stethoscope', label: 'Vet consultation', rate: '10%', payer: 'vet' },
        { icon: 'mdi mdi-shield-check', label: 'Insurance premium', rate: '10%', payer: 'insurance provider' }
      ],

      footerColumns: [
        { heading: 'Marketplace', links: [{ text: 'Browse Listings', url: '/marketplace' }, { text: 'Sell Livestock', url: '/sell/create' }, { text: 'Buy Requests', url: '/marketplace/buy-requests' }, { text: 'Agro-Inputs', url: '/shop' }, { text: 'Market Prices', url: '/market' }] },
        { heading: 'Services', links: [{ text: 'Find a Vet', url: '/vets' }, { text: 'Transport', url: '/transport' }, { text: 'Insurance', url: '/insurance' }, { text: 'AI Symptom Check', url: '/vet/ai-check' }, { text: 'Farm Management', url: '/farm' }] },
        { heading: 'Community', links: [{ text: 'Farmer Forum', url: '/forum' }, { text: 'Learning Hub', url: '/learn' }, { text: 'Market Reports', url: '/market' }, { text: 'Pricing', url: '#pricing' }, { text: 'Help Center', url: '/forum' }] },
        { heading: 'Company', links: [{ text: 'About Us', url: '#' }, { text: 'Careers', url: '#' }, { text: 'Blog', url: '#' }, { text: 'Privacy Policy', url: '#' }, { text: 'Terms of Service', url: '#' }] }
      ]
    };
  },
  computed: {
    currentYear() { return new Date().getFullYear(); },
    themeCardStyle() {
      return this.darkMode
          ? 'background:#141414 !important; background-color:#141414 !important; border:1px solid #1E1E1E !important;'
          : 'background:#FFFFFF !important; background-color:#FFFFFF !important; border:1px solid #E8E2DA !important;';
    },
    themeCardBodyStyle() {
      return this.darkMode
          ? 'background:#141414 !important; background-color:#141414 !important; color:#F5F0E8 !important;'
          : 'background:#FFFFFF !important; background-color:#FFFFFF !important; color:#1A1A1A !important;';
    },
    themeHeadingStyle() {
      return this.darkMode
          ? 'color:#F5F0E8 !important;'
          : 'color:#1A1A1A !important;';
    },
    themeMutedStyle() {
      return this.darkMode
          ? 'color:#A09888 !important;'
          : 'color:#555555 !important;';
    }
  },
  mounted() {
    this.syncThemeState();
    window.__flockrSetTheme(this.darkMode ? 'dark' : 'light');
    this.setupThemeObserver();
    window.addEventListener('scroll', this.handleScroll);
    this.checkLoginState();
    this.initializePage();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('storage', this.syncThemeState);
    if (this.themeObserver) {
      this.themeObserver.disconnect();
      this.themeObserver = null;
    }
  },
  methods: {
    syncThemeState() {
      const docTheme = document.documentElement.getAttribute('data-theme');
      const storedTheme = localStorage.getItem('flockr_theme');
      const resolvedTheme = docTheme || storedTheme || 'light';
      this.darkMode = resolvedTheme !== 'light';
    },

    setupThemeObserver() {
      this.themeObserver = new MutationObserver(() => {
        this.syncThemeState();
      });
      this.themeObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-theme']
      });
      window.addEventListener('storage', this.syncThemeState);
    },

    toggleTheme() {
      this.darkMode = !this.darkMode;
      const theme = this.darkMode ? 'dark' : 'light';
      localStorage.setItem('flockr_theme', theme);
      window.__flockrSetTheme(theme);
    },

    photoUrl(p) {
      if (!p) return '';
      if (p.startsWith && p.startsWith('http')) return p;
      return uploads + String(p).replace('uploads/', '');
    },

    handleScroll() { this.isScrolled = window.scrollY > 50; },
    scrollTo(id) { var el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); },

    checkLoginState() {
      var loggedIn = sessionStorage.getItem('isLoggedIn');
      if (loggedIn) {
        this.isLoggedIn = true;
        var name = sessionStorage.getItem('userName') || '';
        this.userName = name;
        this.userAvatar = sessionStorage.getItem('userAvatar') || '';
        var parts = name.split(' ');
        this.userInitials = parts.map(function(p) { return p.charAt(0).toUpperCase(); }).join('').substring(0, 2);
      }
    },

    logout() {
      sessionStorage.clear();
      localStorage.removeItem('authToken');
      this.isLoggedIn = false;
      this.userName = '';
      this.userInitials = '';
      this.showUserDrop = false;
      this.mobileMenuOpen = false;
      this.$router.push('/');
    },

    async initializePage() {
      this.fetchSpecies();
      this.fetchListings();
    },

    // ============ API CALLS ============

    async fetchSpecies() {
      this.loadingSpecies = true;
      try {
        const response = await executeJson({ function: "getAnimalSpecies" }, flocker);
        if (response.data.success) {
          const species = response.data.data.species || [];
          this.speciesList = species.map(sp => ({
            key: String(sp.id),
            name: sp.name,
            icon: this.getSpeciesIcon(sp.name)
          }));
        }
      } catch (e) {
        console.error('Error fetching species:', e);
      } finally {
        this.loadingSpecies = false;
      }
    },

    async fetchListings(speciesFilter) {
      this.loadingListings = true;
      try {
        const params = {
          function: "searchListings",
          limit: 4,
          page: 1,
          sortBy: "newest"
        };
        if (speciesFilter && speciesFilter !== 'all') {
          params.speciesId = speciesFilter;
        }
        const response = await executeJson(params, flocker);
        if (response.data.success) {
          this.sampleListings = response.data.data.listings || [];
          // Use first 3 for phone mockup
          this.phoneListings = (response.data.data.listings || []).slice(0, 3);
        }
      } catch (e) {
        console.error('Error fetching listings:', e);
      } finally {
        this.loadingListings = false;
      }
    },

    filterBySpecies(speciesKey) {
      this.activeSpecies = speciesKey;
      this.fetchListings(speciesKey);
    },

    // ============ HELPERS ============

    formatPrice(val) {
      if (!val) return '0';
      return Number(val).toLocaleString('en-KE');
    },

    getInitials(name) {
      if (!name) return '?';
      var parts = name.trim().split(' ');
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name.slice(0, 2).toUpperCase();
    },

    getSpeciesIcon(speciesName) {
      if (!speciesName) return 'mdi mdi-paw';
      var s = speciesName.toLowerCase();
      if (s.includes('cattle') || s.includes('cow') || s.includes('bull') || s.includes('heifer')) return 'mdi mdi-cow';
      if (s.includes('goat')) return 'mdi mdi-alpha-g-circle';
      if (s.includes('sheep') || s.includes('ram') || s.includes('ewe') || s.includes('dorper')) return 'mdi mdi-sheep';
      if (s.includes('poultry') || s.includes('chicken') || s.includes('kienyeji') || s.includes('bird')) return 'mdi mdi-bird';
      if (s.includes('pig') || s.includes('sow') || s.includes('boar')) return 'mdi mdi-pig';
      if (s.includes('camel')) return 'mdi mdi-alpha-c-circle';
      return 'mdi mdi-paw';
    }
  }
};
</script>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
.light-mode{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}

.landing-theme-heading{color:var(--fm-h)!important}
.landing-theme-text{color:var(--fm-m)!important}
.landing-theme-muted{color:var(--fm-s)!important}
.landing-theme-disabled{color:var(--fm-s)!important;opacity:.75}
.landing-text-17{font-size:17px}
.landing-title-15{font-size:15px}
.landing-copy-14{font-size:14px;line-height:1.6}
.landing-copy-13{font-size:13px;line-height:1.6}

/* Override custom.css dark card backgrounds */
html[data-theme="light"] .landing-page-root .card,
html[data-theme="light"] .card.landing-feature-card,
html[data-theme="light"] .card.landing-step-card,
html[data-theme="light"] .card.landing-listing-card,
html[data-theme="light"] .card.landing-eco-card,
html[data-theme="light"] .card.landing-escrow-card,
html[data-theme="light"] .card.landing-pricing-card { background-color:#FFFFFF!important; background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .card-body { color:#1A1A1A!important; }

html[data-theme="dark"] .landing-feature-card .card-body,
html[data-theme="dark"] .landing-step-card .card-body,
html[data-theme="dark"] .landing-listing-card .card-body,
html[data-theme="dark"] .landing-eco-card .card-body,
html[data-theme="dark"] .landing-escrow-card .card-body,
html[data-theme="dark"] .landing-pricing-card .card-body { background:#141414!important; background-color:#141414!important; }

html[data-theme="light"] .landing-feature-card .card-body,
html[data-theme="light"] .landing-step-card .card-body,
html[data-theme="light"] .landing-listing-card .card-body,
html[data-theme="light"] .landing-eco-card .card-body,
html[data-theme="light"] .landing-escrow-card .card-body,
html[data-theme="light"] .landing-pricing-card .card-body { background:#FFFFFF!important; background-color:#FFFFFF!important; color:#1A1A1A!important; }



/* Final phone theme override */
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-mockup {
  background:#EFE8DD!important;
  border-color:#D9D0C4!important;
  box-shadow:0 28px 60px rgba(26,26,26,.10)!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-screen {
  background:#FFFFFF!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-icon {
  background:#F7F5F2!important;
  border:1px solid #E8E2DA!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-header,
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-row {
  border-bottom-color:#E8E2DA!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-title {
  color:#1A1A1A!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-meta {
  color:#777!important;
}

</style>
<style scoped>
.landing-nav { position:fixed; top:0; left:0; right:0; z-index:1050; padding:8px 0; transition:all .3s; background:transparent; }
.landing-nav.nav-scrolled { background:rgba(10,10,10,.95); backdrop-filter:blur(20px); border-bottom:1px solid var(--fm-br); }
.landing-nav-link { color:var(--fm-m)!important; text-decoration:none; padding:8px 16px; font-size:14px; font-weight:500; }
.landing-nav-link:hover { color:#BFA164!important; }
.landing-nav-divider { width:1px; height:24px; background:var(--fm-br)!important; margin:0 12px; display:inline-block; }

.landing-user-pill { display:flex; align-items:center; gap:8px; cursor:pointer; padding:4px 10px; border-radius:20px; border:1px solid #2A2520; position:relative; transition:all 0.2s; }
.landing-user-pill:hover { border-color:#BFA164; }
.landing-avatar { width:28px; height:28px; border-radius:50%%; background:rgba(191,161,100,0.2); color:#BFA164; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:700; }
.landing-user-drop { position:absolute; top:60px; right:20px; background:var(--fm-bg1); border:1px solid var(--fm-br); border-radius:10px; padding:8px 0; min-width:180px; z-index:200; box-shadow:0 8px 30px rgba(0,0,0,0.5); }
.landing-drop-item { display:flex; align-items:center; padding:8px 16px; color:var(--fm-m); text-decoration:none; font-size:13px; transition:all 0.2s; }
.landing-drop-item:hover { background:rgba(191,161,100,0.08); color:var(--fm-h); }
.landing-mobile-menu { background:var(--fm-bg1)!important; border-top:1px solid var(--fm-br); padding:16px 24px; }
.landing-mobile-link { display:block; color:var(--fm-m)!important; text-decoration:none; padding:12px 0; border-bottom:1px solid var(--fm-br); font-size:15px; }
.landing-mobile-link:hover { color:#BFA164!important; }
.landing-hero { background:linear-gradient(135deg,#0A0A0A 0%,#1A1510 50%,#0A0A0A 100%); position:relative; overflow:hidden; }
.landing-hero::before { content:''; position:absolute; top:-50%; right:-20%; width:800px; height:800px; background:radial-gradient(circle,rgba(191,161,100,.08) 0%,transparent 70%); border-radius:50%; }
.landing-hero-title { font-size:52px; font-weight:800; line-height:1.1; color:var(--fm-h)!important; }
.landing-hero-subtitle { font-size:18px; line-height:1.7; color:var(--fm-m)!important; max-width:560px; }
.landing-stat-divider { width:1px; height:40px; background:var(--fm-br)!important; }
.landing-phone-mockup { display:inline-block; width:280px; background:#1A1A1A!important; border-radius:28px; border:2px solid #333; padding:16px; box-shadow:0 40px 80px rgba(0,0,0,.5); transition:all .3s ease; }
.landing-phone-screen { background:#111!important; border-radius:18px; padding:16px; transition:all .3s ease; }
.landing-phone-icon { width:48px; height:48px; background:#1A1A1A!important; border-radius:10px; display:flex; align-items:center; justify-content:center; flex-shrink:0; transition:all .3s ease; }
.landing-phone-header { border-bottom:1px solid var(--fm-br); }
.landing-phone-row { border-bottom:1px solid var(--fm-br); }
.landing-phone-title { font-size:13px; color:var(--fm-h)!important; }
.landing-phone-meta { font-size:11px; color:#888!important; }
.landing-feature-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:16px!important; transition:all .3s; cursor:pointer; }
.landing-feature-card .card-body, .landing-step-card .card-body, .landing-listing-card .card-body, .landing-eco-card .card-body, .landing-escrow-card .card-body, .landing-pricing-card .card-body { background:inherit!important; }
.landing-feature-card:hover { border-color:#BFA164!important; transform:translateY(-4px); box-shadow:0 12px 40px rgba(191,161,100,.1); }
.landing-feature-icon { width:52px; height:52px; border-radius:12px; display:flex; align-items:center; justify-content:center; }
.landing-feature-tag { background:rgba(191,161,100,.08); color:var(--fm-s)!important; padding:3px 10px; border-radius:50px; font-size:11px; font-weight:600; margin-right:6px; margin-bottom:4px; display:inline-block; }
.landing-step-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:16px!important; position:relative; }
.landing-step-number { position:absolute; top:-14px; left:50%; transform:translateX(-50%); width:28px; height:28px; background:#BFA164!important; color:#0A0A0A!important; border-radius:50%; font-size:13px; font-weight:800; display:flex; align-items:center; justify-content:center; }
.landing-species-tab { background:var(--fm-bg1)!important; border:1px solid var(--fm-br); color:var(--fm-m)!important; border-radius:50px; font-weight:600; }
.landing-species-tab.active, .landing-species-tab:hover { background:rgba(191,161,100,.15); border-color:#BFA164; color:#BFA164!important; }
.landing-listing-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:14px!important; overflow:hidden; transition:all .3s; }
.landing-listing-card:hover { transform:translateY(-4px); border-color:#444!important; }
.landing-listing-img { position:relative; height:180px; background:linear-gradient(135deg,var(--fm-bg1),var(--fm-bg2)); display:flex; align-items:center; justify-content:center; }
.landing-save-btn { position:absolute; top:10px; right:10px; width:32px; height:32px; background:rgba(0,0,0,.5); border:none; border-radius:50%; color:#fff!important; font-size:16px; display:flex; align-items:center; justify-content:center; cursor:pointer; }
.landing-seller-avatar { width:22px; height:22px; background:#BFA164!important; color:#0A0A0A!important; border-radius:50%; font-size:10px; font-weight:700; display:flex; align-items:center; justify-content:center; }
.landing-eco-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:16px!important; transition:all .3s; }
.landing-eco-card:hover { border-color:#BFA164!important; transform:translateY(-4px); }
.landing-escrow-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:20px!important; }
.landing-escrow-icon { width:60px; height:60px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:24px; }
.landing-escrow-mid { width:70px!important; height:70px!important; font-size:28px!important; }
.landing-tl-dot { width:12px; height:12px; border-radius:50%; border:2px solid #2A2520; flex-shrink:0; }
.landing-tl-dot.active { background:#BFA164!important; border-color:#BFA164; }
.landing-pricing-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:20px!important; position:relative; transition:all .3s; }
.landing-pricing-card:hover { border-color:#444!important; }
.landing-pricing-popular { border-color:#BFA164!important; }
.landing-popular-badge { position:absolute; top:-12px; left:50%; transform:translateX(-50%); background:#BFA164!important; color:#0A0A0A!important; padding:4px 16px; border-radius:50px; font-size:11px; font-weight:800; letter-spacing:1px; white-space:nowrap; }
.landing-social-icon { width:36px; height:36px; background:var(--fm-bg1)!important; border:1px solid #2A2520; border-radius:8px; display:flex; align-items:center; justify-content:center; color:var(--fm-s)!important; font-size:18px; text-decoration:none; }
.landing-social-icon:hover { border-color:#BFA164; color:#BFA164!important; }
@media(max-width:991px){ .landing-hero-title{font-size:38px} }
@media(max-width:575px){ .landing-hero-title{font-size:30px} .landing-hero-subtitle{font-size:15px} }
/* Theme Toggle */
.lp-theme-toggle {
  position:fixed; top:12px; right:16px; z-index:1060;
  width:40px; height:40px; border-radius:50%;
  background:var(--fm-bg3); border:1px solid #2A2520;
  color:#BFA164; cursor:pointer; transition:all .3s;
  display:flex; align-items:center; justify-content:center;
  box-shadow:0 2px 8px rgba(0,0,0,.4);
}
.lp-theme-toggle:hover { transform:scale(1.1); box-shadow:0 4px 12px rgba(191,161,100,.3); }
.light-mode .lp-theme-toggle { background:#FFFFFF; border-color:#E0D8D0; box-shadow:0 2px 8px rgba(0,0,0,.1); }
@media(max-width:991px){ .lp-theme-toggle{ display:none; } }
.lp-theme-toggle-mobile {
  width:38px; height:38px; border-radius:50%;
  background:var(--fm-bg3); border:1px solid #2A2520;
  color:#BFA164; cursor:pointer; transition:all .2s;
  display:flex; align-items:center; justify-content:center; flex-shrink:0;
}
.light-mode .lp-theme-toggle-mobile { background:#F7F5F2; border-color:#E0D8D0; color:#BFA164; }

/* Hide floating toggle on mobile - shown inline instead */
@media(max-width:991.98px){ .lp-theme-toggle { display:none; } }

/* Mobile theme toggle (inline with hamburger) */
.lp-theme-toggle-mobile {
  width:36px; height:36px; border-radius:50%;
  background:var(--fm-bg3); border:1px solid #2A2520;
  color:#BFA164; cursor:pointer; transition:all .3s;
  display:flex; align-items:center; justify-content:center;
  padding:0;
}
.lp-theme-toggle-mobile:hover { transform:scale(1.05); }
.light-mode .lp-theme-toggle-mobile { background:#F7F5F2; border-color:#E0D8D0; }

/* ===== LIGHT MODE OVERRIDES ===== */
.light-mode { background:#FFFFFF!important; }
.light-mode .landing-nav.nav-scrolled { background:rgba(255,255,255,.95)!important; border-bottom-color:#E8E2DA!important; }
.light-mode .landing-nav-link { color:#555!important; }
.light-mode .landing-nav-link:hover { color:#BFA164!important; }
.light-mode .landing-nav-divider { background:#E0D8D0!important; }
.light-mode .landing-user-pill { border-color:#E0D8D0; }
.light-mode .landing-user-pill span { color:#1A1A1A!important; }
.light-mode .landing-user-drop { background:#FFFFFF!important; border-color:#E8E2DA!important; box-shadow:0 8px 30px rgba(0,0,0,.12)!important; }
.light-mode .landing-drop-item { color:#555!important; }
.light-mode .landing-drop-item:hover { background:rgba(191,161,100,.08); color:#1A1A1A!important; }
.light-mode .landing-mobile-menu { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode .landing-mobile-link { color:#555!important; border-color:#E8E2DA!important; }

/* ===== COMPREHENSIVE LIGHT MODE ===== */
/* Root */
.light-mode .landing-page-root { background:#FFFFFF!important; }

/* Hero — switch to light warm bg */
.light-mode .landing-hero { background:linear-gradient(135deg,#F7F5F2 0%,#FFF8F0 50%,#F7F5F2 100%)!important; }
.light-mode .landing-hero::before { background:radial-gradient(circle,rgba(191,161,100,.06) 0%,transparent 70%)!important; }
.light-mode .landing-hero-title { color:#1A1A1A!important; }
.light-mode .landing-hero-subtitle { color:#555!important; }

/* Sections */
.light-mode section[style*="background:#0A0A0A"] { background:#FFFFFF!important; }
.light-mode section[style*="background:#0F0F0F"] { background:#F7F5F2!important; }
.light-mode section[style*="background:linear-gradient"] { background:linear-gradient(135deg,#F7F5F2,#FFFFFF)!important; border-top-color:#E8E2DA!important; }

/* CATCH-ALL text overrides — covers h2, h3, h5, h6, div, span, p, li, strong */
.light-mode [style*="color:#F5F0E8"] { color:#1A1A1A!important; }
.light-mode [style*="color:#6B6356"] { color:#777!important; }
.light-mode [style*="color:#A09888"] { color:#555!important; }
.light-mode [style*="color:var(--fm-h"] { color:#1A1A1A!important; }
.light-mode [style*="color:var(--fm-s"] { color:#777!important; }
.light-mode [style*="color:var(--fm-m"] { color:#555!important; }
/* Phone mockup accents in light mode */
.light-mode .landing-phone-screen [style*="color:#BFA164"] { color:#BFA164!important; }

/* CATCH-ALL backgrounds */
.light-mode [style*="background:#141414"],
.light-mode [style*="background:#0F0F0F"],
.light-mode [style*="background:var(--fm-bg"] { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode [style*="background:#1E1E1E"],
.light-mode [style*="background:#0A0A0A"] { background:#F7F5F2!important; }
.light-mode [style*="background:#1A1510"],
.light-mode [style*="background:#1a1510"] { background:#FFF8F0!important; border-color:#E8E2DA!important; }

/* CATCH-ALL borders */
.light-mode [style*="border-bottom:1px solid #2A2520"],
.light-mode [style*="border-bottom:1px solid #1E1E1E"],
.light-mode [style*="border-bottom:1px solid var(--fm-br"] { border-bottom-color:#E8E2DA!important; }
.light-mode [style*="border-top:1px solid #2A2520"],
.light-mode [style*="border-top:1px solid var(--fm-br"] { border-top-color:#E8E2DA!important; }
.light-mode [style*="border:1px solid #2A2520"],
.light-mode [style*="border:1px solid #1E1E1E"],
.light-mode [style*="border:1px solid var(--fm-br"] { border-color:#E8E2DA!important; }

/* Preserve accent colors */
.light-mode [style*="color:#BFA164"] { color:#BFA164!important; }
.light-mode [style*="color:#50C878"] { color:#50C878!important; }
.light-mode [style*="color:#4FC3F7"] { color:#4FC3F7!important; }
.light-mode [style*="color:#FF6B6B"] { color:#FF6B6B!important; }
.light-mode [style*="color:#FF9800"] { color:#FF9800!important; }

/* Scoped class overrides */
.light-mode .landing-stat-divider { background:#E0D8D0!important; }
.light-mode .landing-hero-subtitle { color:#555!important; }

/* Footer */
.light-mode footer { background:#F7F5F2!important; color:#555!important; border-top-color:#E8E2DA!important; }
.light-mode footer a { color:#555!important; }
.light-mode footer a:hover { color:#BFA164!important; }
.light-mode footer div[style*="border-top"] { border-top-color:#E8E2DA!important; }
.light-mode footer div[style*="color"] { color:#777!important; }
.light-mode footer p[style*="color:#F5F0E8"] { color:#1A1A1A!important; }
.light-mode footer p[style*="color:#A09888"] { color:#555!important; }
.light-mode footer [style*="border-top:1px solid #2A2520"] { border-top-color:#E8E2DA!important; }

/* Feature cards */
.light-mode .landing-feature-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode .landing-feature-card:hover { box-shadow:0 12px 40px rgba(191,161,100,.08)!important; }
.light-mode .landing-feature-tag { background:rgba(191,161,100,.1)!important; color:#8B7355!important; }

/* Step cards */
.light-mode .landing-step-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }

/* Species tabs */
.light-mode .landing-species-tab { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#555!important; }

/* Listing cards */
.light-mode .landing-listing-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode .landing-listing-card:hover { border-color:#BFA164!important; }
.light-mode .landing-listing-img { background:linear-gradient(135deg,#F0EBE4,#E8E2DA)!important; }

/* Ecosystem cards */
.light-mode .landing-eco-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode .landing-eco-card:hover { border-color:#BFA164!important; }

/* Pricing cards */
.light-mode .landing-pricing-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode .landing-pricing-popular { border-color:#BFA164!important; }

/* Phone mockup - light theme */
.light-mode .landing-phone-mockup { background:#EFE8DD!important; border-color:#D9D0C4!important; box-shadow:0 28px 60px rgba(26,26,26,.10)!important; }
.light-mode .landing-phone-screen { background:#FFFFFF!important; }
.light-mode .landing-phone-icon { background:#F7F5F2!important; border:1px solid #E8E2DA!important; }
.light-mode .landing-phone-header,
.light-mode .landing-phone-row { border-bottom-color:#E8E2DA!important; }
.light-mode .landing-phone-title { color:#1A1A1A!important; }
.light-mode .landing-phone-meta { color:#777!important; }

/* Drop item hover */
.light-mode .landing-drop-item:hover { color:#1A1A1A!important; }

/* Hero title - keep light on dark hero */
/* .landing-hero stays dark in both themes */

/* Escrow card */
.light-mode .landing-escrow-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }

/* Force Bootstrap .card backgrounds to follow theme */
.light-mode .card { background-color:var(--fm-bg1)!important; border-color:var(--fm-br)!important; }

/* Final hard override for card surfaces across light theme */
.landing-page-root.light-mode .landing-feature-card,
.landing-page-root.light-mode .landing-step-card,
.landing-page-root.light-mode .landing-listing-card,
.landing-page-root.light-mode .landing-eco-card,
.landing-page-root.light-mode .landing-escrow-card,
.landing-page-root.light-mode .landing-pricing-card {
  background:#FFFFFF !important;
  background-color:#FFFFFF !important;
  border:1px solid #E8E2DA !important;
  box-shadow:none;
}

.landing-page-root.light-mode .landing-feature-card .card-body,
.landing-page-root.light-mode .landing-step-card .card-body,
.landing-page-root.light-mode .landing-listing-card .card-body,
.landing-page-root.light-mode .landing-eco-card .card-body,
.landing-page-root.light-mode .landing-escrow-card .card-body,
.landing-page-root.light-mode .landing-pricing-card .card-body {
  color:#1A1A1A !important;
}

.landing-page-root.light-mode .landing-feature-card h5,
.landing-page-root.light-mode .landing-step-card h6,
.landing-page-root.light-mode .landing-listing-card h6,
.landing-page-root.light-mode .landing-eco-card h5,
.landing-page-root.light-mode .landing-pricing-card .landing-theme-heading {
  color:#1A1A1A !important;
}


/* Final phone theme override */
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-mockup {
  background:#EFE8DD!important;
  border-color:#D9D0C4!important;
  box-shadow:0 28px 60px rgba(26,26,26,.10)!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-screen {
  background:#FFFFFF!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-icon {
  background:#F7F5F2!important;
  border:1px solid #E8E2DA!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-header,
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-row {
  border-bottom-color:#E8E2DA!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-title {
  color:#1A1A1A!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-meta {
  color:#777!important;
}

</style>